<div class="categories container">

  <!-- BreadCrumbs -->
  <div class="row breadcrumbs">
    <div class="col-md-12">
      <div class="btn-group btn-breadcrumb">
        <a (click)="mainPageNavigate()" title="Grassroot Labs Home" class="btn btn-default"><i class="glyphicon glyphicon-home"></i></a>
        <a (click)="allTestsNavigate()"  title="Tests" class="btn btn-default">Tests</a>
        <a [title]="categoryName" routerLink="/category/{{idCategory}}" class="btn btn-default">{{categoryName}}</a>
      </div>
    </div>
  </div>



  <mat-accordion [hideToggle]="true" [displayMode]="'flat'">
    <mat-expansion-panel *ngFor="let test of tests; let i=index" [expanded]="i === 0" #f (opened)="f.close()"
                         (click)="testNavigate(test)">
      <mat-expansion-panel-header [collapsedHeight]="'fit-content'" [expandedHeight]="'fit-content'" style="height: 100%;">
        <div class="col-md-1 imgcontainer">
          <img src="{{ imageURL + test.imageId }}" class="img-responsive">
        </div>
        <div class="col-md-11 pricelist">
          <h4>{{test.name}}</h4>
          <div>
            <small>Price:</small>
            <span style="font-size: 16px;">{{test.masterPrice | currency}}</span>
          </div>
          <div>
            <small>CPT:</small>
            <span>{{test.cpt || '-'}}</span>
          </div>
        </div>
        <div class="col-md-2 hidden-xs text-right top10">
          <button class="btn btn-primary" (click)="testNavigate(test)">
            <i class="fa fa-plus-square-o"></i> View
          </button>
        </div>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
  </mat-accordion>

  <ngb-pagination [collectionSize]="testsCount" [(page)]="page" [maxSize]="10" (pageChange)="onPageChange(page)"
                  [rotate]="true" [ellipses]="false" [boundaryLinks]="true"></ngb-pagination>



</div>
